import { render, staticRenderFns } from "./promo-lock.vue?vue&type=template&id=5e706c2a"
import script from "./promo-lock.vue?vue&type=script&lang=js"
export * from "./promo-lock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports